import { render, staticRenderFns } from "./BindingId.vue?vue&type=template&id=6ca7b59c&scoped=true&"
import script from "./BindingId.vue?vue&type=script&lang=js&"
export * from "./BindingId.vue?vue&type=script&lang=js&"
import style0 from "./BindingId.vue?vue&type=style&index=0&id=6ca7b59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7b59c",
  null
  
)

export default component.exports